'use client';

import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import Close from '@alltrails/denali/icons/Close';
import { clearNaturalLanguageSearchAndFilters } from '@alltrails/explore-service/redux/exploreServiceSlice';
import ExploreNavigationBase from '@/components/ExploreNavigationBase/ExploreNavigationBase';
import useNaturalLanguageResultSelect from '@/hooks/useNaturalLanguageResultSelect';
import useStreetAddressSelect from '@/hooks/useStreetAddressSelect';
import { useAppDispatch, useAppSelector } from '@/utils/redux';
import styles from './ExploreNavigation.module.scss';

const ExploreNavigation = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const { locationResult, naturalLanguageQuery, searchIsLoading } = useAppSelector(state => ({
    locationResult: state.exploreService.locationResult,
    naturalLanguageQuery: state.exploreService.naturalLanguageQuery,
    searchIsLoading: state.exploreService.searchIsLoading
  }));

  const [searchHasFocus, setSearchHasFocus] = useState(false);

  const clearNaturalLanguageQueryButton = useMemo(() => {
    if (!naturalLanguageQuery || (naturalLanguageQuery && searchIsLoading) || searchHasFocus) {
      return null;
    }

    return (
      <IconButton
        className={styles.clearFocus}
        icon={{ Component: Close }}
        onClick={() => {
          dispatch(clearNaturalLanguageSearchAndFilters());
        }}
        size="sm"
        title={intl.formatMessage({ defaultMessage: 'Clear' })}
        variant="ghost"
      />
    );
  }, [dispatch, intl, naturalLanguageQuery, searchIsLoading, searchHasFocus]);

  const handleAddressSelect = useStreetAddressSelect();
  const handleNaturalLanguageResultSelect = useNaturalLanguageResultSelect();

  return (
    <ExploreNavigationBase
      onInputBlur={() => setSearchHasFocus(false)}
      onInputFocus={() => setSearchHasFocus(true)}
      searchOnAddressSelect={handleAddressSelect}
      searchOnNaturalLanguageResultSelect={handleNaturalLanguageResultSelect}
      searchRequestLoading={Boolean(naturalLanguageQuery && searchIsLoading)}
      searchValue={naturalLanguageQuery ?? locationResult?.name}
      tertiarySearchElement={clearNaturalLanguageQueryButton}
    />
  );
};

export default ExploreNavigation;
